export const environment = {
  production: false,
  pre: false,
  qa: true,

  allowedParentOriginOTP: '$(allowedParentOriginOTP)',
  companyContactEmail: 'support@example.com',

  apiClient: 'https://clients.demo.ri.dentsutracking.com/dt',
  mfaClient: 'https://auth.demo.ri.dentsutracking.com/dt',

  awsMapApiKey: 'v1.public.eyJqdGkiOiIxMjhhY2ZiYy1mMmI3LTQzMjAtYWYzNC0yM2U0ZTRlNzRjYzAifYqKOgWP68CzYPSSXmKijn7z7--xJ0yxD4VqJKUlATAAqPyxFfPnuXT1LDiZ0gh1OmhbyUPTsSh08nakkQ8NUKuBn-FRBqlJitXy91OlRjpNRCMlMeW-vgFgBsL3mYJeCECqjIeKcTZfD-OJ5caL1UeNhsfTbtlRwnAnMAcRO2mL8t-t5lcxxkDQIxJUQWDO-TCW3K2nYxSIqG6bNzGsoGu-vsNrXR45HHZPCuzFu8czAjsQlH0SvPA0HN2Snhga9QR-98L6z5HlDZsvIzgRheN_ukotA5C90Za6OzC48gn5_9g16WSwi3m9DVcDWP2Q5WgE-uT4foFv-YZ6VNkJHFU.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4',
  awsRegion: 'eu-west-1',

  dynamsoft: {
    productKey: 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAwNTAzMjkzLXIxNzM5Mjg3NDYwIiwibWFpblNlcnZlclVSTCI6Imh0dHBzOi8vbWx0cy5keW5hbXNvZnQuY29tLyIsIm9yZ2FuaXphdGlvbklEIjoiMTAwNTAzMjkzIiwic3RhbmRieVNlcnZlclVSTCI6Imh0dHBzOi8vc2x0cy5keW5hbXNvZnQuY29tLyIsImNoZWNrQ29kZSI6NjU1OTIyODg3fQ=='
  }
};
